/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinkingOptionsApp} from '../api'

 export const useQueryGetInstrumentLinkingOptionsApp = createReactQueryHook('getInstrumentLinkingOptionsApp', getInstrumentLinkingOptionsApp)
